import React from "react";

// Get locale from cookie
const getLocaleFromCookie = () => {
  const match = document.cookie.match(/(^|;)\s*locale=([^;]*)/);
  return match ? decodeURIComponent(match[2]) : "it"; // fallback to Italian
};

const ProjectTitle = ({ data }) => {
  const locale = getLocaleFromCookie();

  if (!data) {
    return (
      <div className="container py-5 text-center">
        <p className="text-muted">No project data provided.</p>
      </div>
    );
  }

  const {
    title = "Untitled Project",
    ShotDate,
    Country,
    place,
    Abstract,
  } = data;

  const abstract = Array.isArray(Abstract) ? Abstract : [];

  const getLocalizedCountry = (code) => {
    try {
      return new Intl.DisplayNames([locale], { type: "region" }).of(code);
    } catch {
      return code || "";
    }
  };

  const formattedDate = ShotDate
    ? new Date(ShotDate).toLocaleDateString(locale, {
        month: "long",
        year: "numeric",
      }).toUpperCase()
    : "";

  const formattedPlace = place ? place.toUpperCase() : "";
  const formattedCountry = Country ? getLocalizedCountry(Country).toUpperCase() : "";

  const metadataLine = [
    formattedDate,
    formattedPlace && formattedCountry ? `${formattedPlace}, ${formattedCountry}` : formattedPlace || formattedCountry,
  ]
    .filter(Boolean)
    .join(" - ");

  const renderAbstractBlocks = () => {
    return abstract
      .filter(
        (block) =>
          block?.type === "paragraph" &&
          Array.isArray(block.children) &&
          block.children.some(
            (child) => typeof child.text === "string" && child.text.trim()
          )
      )
      .map((block, i) => {
        const paragraphText = block.children
          .map((child) =>
            typeof child.text === "string" ? child.text.trim() : ""
          )
          .join("")
          .trim();

        if (!paragraphText) return null;

        return (
          <div key={i} className="col-12">
            <p className="lead display-6 text-dark">{paragraphText}</p>
          </div>
        );
      });
  };

  return (
    <div className="container mt-10 mb-10">
      <div className="row justify-content-center">
        <div className="col-12">
          <h1 className="mb-1 text-black" style={{ fontWeight: "bold" }}>
            {title}
          </h1>

          {metadataLine && (
            <small className="eyebrow text-black mb-5 d-block">
              {metadataLine}
            </small>
          )}
        </div>

        {renderAbstractBlocks()}
      </div>
    </div>
  );
};

export default ProjectTitle;
